import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'logout-dialog',
    templateUrl: 'logout-dialog.html',
  })
  export class LogoutDialog {
    constructor(private dialogRef: MatDialogRef<LogoutDialog>) {}
  
    yes(): void {
      this.dialogRef.close(true);
    }
  }
  